import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * useScrollReveal
 * Observer minimal per aggiungere la classe `.in-view` a qualunque elemento
 * con attributo `data-reveal`. Attiva animazioni CSS di ingresso.
 * Si riesegue ad ogni cambio di route così le nuove pagine vengono osservate.
 */
export default function useScrollReveal() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) return;

    // Piccolo delay per lasciare al DOM il tempo di renderizzare la nuova route.
    const t = setTimeout(() => {
      const els = document.querySelectorAll("[data-reveal]:not(.in-view)");
      if (!els.length) return;
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("in-view");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
      );
      els.forEach((el) => io.observe(el));

      // Safety net: se qualcosa non viene mai osservato, dopo 2s forziamo il reveal.
      const safety = setTimeout(() => {
        document.querySelectorAll("[data-reveal]:not(.in-view)")
          .forEach((el) => el.classList.add("in-view"));
      }, 2000);

      return () => { io.disconnect(); clearTimeout(safety); };
    }, 60);

    return () => clearTimeout(t);
  }, [pathname]);
}
